// places types
export enum AirportType {
  city = 'city',
  airport = 'airport',
}

type Location = {
  lon: number
  lat: number
}

interface Place {
  country: string
  country_iata: string
  iata: string
  rating: number
  name: string
  location: Location
  type: AirportType
  nearby: any
}

export interface Airport extends Place {
  city_iata: string
  city: string
  type: AirportType.airport
}

export interface City extends Place {
  type: AirportType.city
}

export interface CityWithAirportsIata extends City {
  airportsIata: string | string[]
}

export type PlaceType = Airport | City

export const isAirport = (obj: PlaceType): obj is Airport => {
  return 'city' in obj
}

export const isCity = (obj: PlaceType): obj is City => {
  return !('city' in obj)
}

export interface PlaceSelectList {
  fullName: string
  name: string
  rating: Place['rating']
  iata: Place['iata']
  iataToFetch: string | string[]
  id: string
  type: AirportType
  hasCityWithin: boolean
  lat: number
  lon: number
}

// routes types
export type AirportDetailsType = {
  iata: string
  name: string
  city: string
}

export type PathType = {
  name: string
  lat: number
  lon: number
}

type FlightCarrierType = {
  carrier: string
  carrier_name: string | null
  [key: string]: any
}

export interface Flight {
  code: string
  from: string
  to: string
  departs_at: string
  arrives_at: string
  carriers: FlightCarrierType[]
  distance: number | null
  carrier_name: string | null
  overnight: boolean
  [key: string]: any
}

export interface Route {
  path: PathType[]
  flights: Flight[]
  total_time: number
  optimality_score: number
  n_tickets: number
  [key: string]: any
}

export interface CompletedRoute extends Route {
  id: string
  overnight: boolean
}

export interface GrouppedRoute extends CompletedRoute {
  groupMinMaxTime: [number, number] | [number]
  groupSize: number
}

export type RoutesAirportsType = {
  routes: Route[]
  airports: Record<string, AirportDetailsType>
}

export type GroupedRoutesAirportsType = {
  routes: GrouppedRoute[]
  airports: RoutesAirportsType['airports']
}

// api
export type FetchRoutesOptions = {
  source: string | string[]
  destination: string | string[]
  date: string
  byArrival: string
}

type DirectRoutesSource = {
  source: string | string[]
}

type DirectRoutesDestination = {
  destination: string | string[]
}

export type FetchDirectRoutesOptions = DirectRoutesSource | DirectRoutesDestination

export enum SERVER_ERROR_CODES {
  limitError = 429,
}

export type DirectRoutes = AirportDetailsType & PathType
